import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-only-loader',
  templateUrl: './only-loader.component.html',
  styleUrls: ['./only-loader.component.scss'],
})
export class OnlyLoaderComponent implements OnInit {
  @Input() tamanho: string = 'medio';
  public classeTamanhoLogo: string = 'logo--';
  public classeTamanhoDualRing: string = 'dual-ring--';

  constructor() {}

  ngOnInit(): void {
    this.carregarTamanhoDoLoader();
  }

  carregarTamanhoDoLoader(): void {
    this.classeTamanhoDualRing = this.classeTamanhoDualRing.concat(
      this.tamanho
    );
    this.classeTamanhoLogo = this.classeTamanhoLogo.concat(this.tamanho);
  }
}
